'use client';

import { useEffect, useState } from 'react';

/**
 * Tracks whether a modal overlay (any element with aria-modal="true", e.g. a
 * HeroUI Modal or Drawer) is currently open anywhere in the document.
 *
 * The persistent assistant floats above legacy portal chrome (z-index 1250),
 * which would also place it above HeroUI's modal backdrop (z-50). Consumers
 * use this to drop beneath the backdrop while a modal is open so the assistant
 * is dimmed and blocked like the rest of the page (M4S-5302).
 */
export function useModalOverlayOpen(): boolean {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const update = () => setIsModalOpen(document.querySelector('[aria-modal="true"]') !== null);
        update();
        const observer = new MutationObserver(update);
        observer.observe(document.body, { childList: true, subtree: true });
        return () => observer.disconnect();
    }, []);

    return isModalOpen;
}
